<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col w-full mb-6">
                <h3 class="text-primary">{{ $t('dashboard.categoryInformation') }}</h3>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label required">{{ $t('library.categoryTitle') }}</label>
                <vs-input class="w-full" v-model="categoryInfo.title" v-validate="'required'"
                          name="categoryTitle"></vs-input>
                <span class="text-danger text-sm">{{ errors.first('categoryTitle') }}</span>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full md:mt-0 mt-2">
                <label class="vs-input--label">{{ $t('library.color') }}</label>
                <vs-input class="colorInput w-full" v-model="categoryInfo.color" type="color"></vs-input>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                <label class="vs-input--label">{{ $t('library.description') }}</label>
                <vs-textarea class="w-full" v-model="categoryInfo.description" v-validate="''"
                          name="categoryDescription"></vs-textarea>
                <span class="text-danger text-sm">{{ errors.first('categoryDescription') }}</span>
            </div>

            <div class="vx-col w-full">
                <div class="flex flex-wrap justify-end mt-6">
                    <vs-button class="ml-auto" @click="saveChanges" :disabled="!validateForm">{{
                            `${isUpdate ?
                                $t('button.update') : $t('button.create')}`
                        }}
                    </vs-button>
                    <vs-button class="ml-4" type="border" color="warning" @click="$router.go(-1)" v-if="!this.isUpdate">
                        {{ $t('button.back') }}
                    </vs-button>
                    <vs-button class="ml-4" type="border" color="danger" @click="closePopup" v-else>
                        {{ $t('button.close') }}
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DetailsCategory",
    props: {
        categoryId: {
            default: null,
            type: Number
        }
    },
    data() {
        return {
            categoryInfo: {
                title: null,
                color: null,
                description: null,
                order: null,
            },
            isUpdate: false,
        }
    },

    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },

    async created() {
        if (this.categoryId) {
            this.isUpdate = true;
            await this.getDetailsCategory();
        }
    },

    methods: {
        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;

            const result = await this.$validator.validateAll();
            if (!result) return;

            let url = this.isUpdate ? `/library/category/update/${this.categoryId}` : '/library/category/create';

            this.$vs.loading();
            this.$crm.post(url, this.categoryInfo).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: `${this.isUpdate ? 'Cập nhật' : 'Tạo mới'} danh mục thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                if (!this.isUpdate) {
                    this.$router.push('/user/manage-category').catch(() => {
                    });
                } else {
                    this.closePopup();
                    this.$store.commit('UPDATE_CATEGORY', true);
                }
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getDetailsCategory() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/library/category/find-by-id/${this.categoryId}`).then(res => {
                    this.$vs.loading.close();
                    resolve(res);
                    this.categoryInfo = res.data;
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        closePopup() {
            this.$eventBus.$emit("close-popup-details-category", {});
        }
    }
}
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}


</style>

<style lang="scss">
.colorInput .vs-input--input.normal {
    padding: 0.1rem !important;
    height: 37.59px;
}
</style>
